<template>
  <div class="fill-height d-flex flex-column flex-grow-1">
    <div class="d-flex justify-space-between">
      <h2 class="px-2">Prijava nove škode</h2>
    </div>

    <v-card
      class="skodenew pa-lg-4 pa-2 fill-height"
      :elevation="$vuetify.breakpoint.smAndUp > 0 ? 1 : 0"
    >
      <v-btn to="/skode" fab color="white" exact top right absolute>
        <v-icon large color="red">mdi-close</v-icon>
      </v-btn>
      <v-form v-model="valid" ref="form">
        <div class="grid">
          <div class="left-part">
            <h3>Osnovni podatki</h3>
            <v-row class="twocol">
              <div>
                <v-text-field
                  v-model="formFields.Pogodba_ID"
                  type="number"
                  label="Pogodba ID"
                  placeholder="Številka pogodbe"
                  :rules="[v => !!(v > 99999 && v < 99999999999) || 'Dolžina mora biti med 6 in 11 znakov']"
                  required
                  counter="11"
                  flat
                  autofocus
                  @blur="refreshPogodbaData"
                ></v-text-field>

                <div v-if="auxPogodbaData.pogodba" class="ma-0">
                  <v-expansion-panels class="hidden-lg-and-up mb-5">
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <h3>Do zdaj obdelano škod: {{ auxPogodbaData.skode.length }}</h3>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <SkodePrejsnje :data="auxPogodbaData" />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </div>

              <v-menu v-model="datumPicker" :close-on-content-click="false" max-width="290">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatiranDatum"
                    append-icon="mdi-calendar"
                    label="Datum"
                    readonly
                    v-on="on"
                    @click:append="datumPicker = true"
                    @click:clear="formatiranDatum = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="formFields.Datum"
                  @change="datumPicker = false"
                  :first-day-of-week="1"
                  locale="sl-SI"
                ></v-date-picker>
              </v-menu>
            </v-row>

            <v-row class="twocol">
              <v-autocomplete
                v-model="formFields.Delavnica_ID"
                :items="delavnice"
                label="Delavnica"
                placeholder="izberi delavnico"
                no-data-text="Ni podatkov"
                flat
                required
                item-value="ID"
                item-text="Naziv"
                :rules="[(v) => !!v || `Obvezen vnos`]"
              ></v-autocomplete>
              <v-text-field
                v-model="formFields.Kontaktna_oseba"
                type="text"
                label="Kontaktna oseba"
                placeholder="Ime in priimek"
                flat
              ></v-text-field>
            </v-row>

            <v-row class="twocol">
              <v-text-field
                v-model="formFields.Telefon"
                type="tel"
                label="Telefon"
                prefix="+386"
                placeholder="slovenska številka"
                flat
              ></v-text-field>
            </v-row>

            <v-row>
              <v-textarea
                rows="3"
                label="Opis škode"
                v-model="formFields.Opis_skode"
                placeholder="Kratek tekst"
                flat
                auto-grow
              ></v-textarea>
            </v-row>

            <v-row class="twocol">
              <v-currency-field
                v-model="formFields.Znesek_zahtevek"
                label="Znesek zahtevka"
                placeholder
                required
                flat
                reverse
                prefix="€"
              />

              <v-text-field
                name="Znesek_zahtevek"
                v-model="formFields.Aktualni_km"
                type="number"
                label="Aktualni kilometri"
                placeholder
                :rules="[(v) => !!(v > 1000 && v < 999999) || 'Vnesi realne kilometre, med 1000 in 999999']"
                required
                flat
                reverse
              ></v-text-field>
            </v-row>

            <v-row>
              <v-textarea
                rows="3"
                label="Opomba za interno rabo"
                v-model="formFields.Opomba"
                placeholder
                flat
              ></v-textarea>
            </v-row>

            <v-row>
              <v-btn
                type="submit"
                color="primary"
                @click="save"
                :disabled="!valid"
                class="mt-5"
              >Shrani</v-btn>
            </v-row>
          </div>
          <v-divider vertical class="d-none d-lg-flex"></v-divider>
          <div class="right-part d-none d-lg-flex flex-column">
            <div v-if="auxPogodbaData.pogodba">
              <h3 class="pb-5">Do zdaj obdelano škod: {{ auxPogodbaData.skode.length }}</h3>

              <SkodePrejsnje :data="auxPogodbaData" class="hidden-md-and-down" />
            </div>
            <div v-if="auxPogodbaData.errorNotExists">
              <h3 class="red--text">Pogodba ne obstaja</h3>
            </div>
          </div>
        </div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import SkodePrejsnje from "./SkodePrejsnje";
import VCurrencyField from "@/modules/VCurrencyField";

const emptySkodeFormFields = {
  Pogodba_ID: "151694",
  Datum: new Date().toISOString().substr(0, 10),
  Delavnica_ID: null,
  Kontaktna_oseba: "",
  Telefon: "",
  Opis_skode: "",
  Znesek_zahtevek: 0.0,
  Aktualni_km: 0,
  Opomba: "",
  Status: "P"
};

myVars.currentSkodeFormFields = Object.assign({}, emptySkodeFormFields); // this serves as cache for partially entered forms

export default {
  components: {
    SkodePrejsnje,
    VCurrencyField
  },

  data: () => ({
    valid: false,
    datumPicker: false,
    formFields: myVars.currentSkodeFormFields,
    auxPogodbaData: {
      pogodba: null,
      skode: [],
      errorNotExists: false,
      produkt: null
    }
  }),
  created() {
    // console.log("skode new created");
  },
  mounted() {
    // console.log("skode new mounted");
    myVars.currentSkodeFormFields = Object.assign({}, emptySkodeFormFields);
    this.formFields = myVars.currentSkodeFormFields;
  },

  computed: {
    delavnice: e => e.$root.$data.delavnice.selectItems,

    formatiranDatum: {
      get() {
        return this.datum(this.formFields.Datum);
        // const d = new Date(Date.parse(this.formFields.Datum));
        // return d.toLocaleDateString("sl-SI");
      },
      set(valueFromPicker) {
        this.formFields.Datum = valueFromPicker;
      }
    }
  },

  methods: {
    save(e) {
      e.preventDefault();
      this.$refs.form.validate();
      if (this.valid) {
        const that = this;
        const saveFormFields = Object.assign({}, that.formFields);
        myVars.currentSkodeFormFields = Object.assign({}, emptySkodeFormFields);

        this.$axios
          .post(`/skode`, saveFormFields)
          .then(function(response) {
            that.$router.replace("/skode/");
            // // console.log("saved", saveFormFields);
          })
          .catch(function(error) {
            // console.log(error);
          });
      } else {
        console.error(this.form);
      }
    },
    async refreshPogodbaData() {
      let that = this;
      var url = `/v_pogodbe/${this.formFields.Pogodba_ID}`;
      await this.$axios
        .get(url)
        .then(response => (that.auxPogodbaData.pogodba = eval(response.data)));

      this.auxPogodbaData.errorNotExists = !this.auxPogodbaData.pogodba;

      // console.log("pogodba_data:", this.auxPogodbaData);

      var url = `/produkti/${this.auxPogodbaData.pogodba.Produkt_ID}`;
      await this.$axios
        .get(url)
        .then(response => (that.auxPogodbaData.produkt = eval(response.data)));
      var url = `/v_skode_full_by_vin/${this.auxPogodbaData.pogodba.Sasija}`;
      await this.$axios
        .get(url)
        .then(response => (that.auxPogodbaData.skode = eval(response.data)))
        .catch(error => false);
    }
  }
};
</script>

<style scoped lang="scss">
.grid {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 3rem;
}

.twocol {
  display: grid;
  grid-template-columns: 1fr;
}

@media #{map-get($display-breakpoints, 'lg-and-up')} {
  .grid {
    grid-template-columns: 40rem 1px 1fr;
  }

  .twocol {
    grid-template-columns: 1fr 1fr;
    grid-gap: 2rem;
  }
}

.v-expansion-panel::before {
  box-shadow: none;
}

.v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.left-part > * {
  margin: 0;
}
</style>
